import { CryptoManager } from "./CryptoManager";

const storageHelper = {
  getItem: (key) => {
    const name = key + "=";
    const decodedCookie = document.cookie;
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1);
      if (c.indexOf(name) === 0) {
        if (key !== "token")
          return CryptoManager.decryptString(
            c.substring(name.length, c.length)
          );
        else return c.substring(name.length, c.length);
      }
    }
    return null;
  },

  setItem: (key, value, days = 365, expireOn = null) => {
    let encValue = "";
    if (key !== "token") {
      let safeValue = (value === undefined || value === null) ? "" : String(value);
      encValue = CryptoManager.encryptString(safeValue);
    } else {
      encValue = value;
    }

    let expires = "";
    if (expireOn) {
      const d = new Date(expireOn);
      expires = "expires=" + d.toUTCString();
    } else {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "expires=" + d.toUTCString();
    }
    document.cookie = key + "=" + encValue + ";" + expires + ";path=/";
  },

  removeItem: (key) => {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },

  clearStorage: () => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const eqPos = cookies[i].indexOf("=");
      const name =
        eqPos > -1 ? cookies[i].substr(0, eqPos).trim() : cookies[i].trim();
      document.cookie =
        name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
    }
  },

  hasItem: (key) => {
    const decodedCookie = document.cookie;
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1);
      if (c.includes(key + "=")) {
        return true;
      }
    }
    return false;
  },

  getItemByInclude: (key) => {
    const decodedCookie = document.cookie;
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1);
      if (c.includes(key + "=")) {
        const name = key + "=";
        if (key !== "token")
          return CryptoManager.decryptString(
            c.substring(c.indexOf(name) + name.length, c.length)
          );
        else return c.substring(c.indexOf(name) + name.length, c.length);
      }
    }
    return null;
  },
};

export { storageHelper };
